import {Amplify} from 'aws-amplify';
export function configureAmplify() {
  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: process.env.NEXT_PUBLIC_AMPLIFY_GRAPHQL_URL!,
        region: 'ap-south-1',
        defaultAuthMode: 'lambda',
      },
    },
  });
}
